import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { bonusValueRows } from '../data/bonuses';
import { bonusValue, fullPrice, included, price } from '../data/copy';
export function OfferSection() {
  return <section id="oferta" className="defer-paint w-full scroll-mt-6 bg-ink py-12 sm:py-16" aria-labelledby="offer-heading" data-id="element-112" data-mp="dencqtg7qj6f">
      <div className="mx-auto max-w-5xl px-6" data-id="element-113" data-mp="ic6rrvkqizzf">
        <div className="mx-auto max-w-2xl text-center" data-id="element-114" data-mp="ifkux6183d7x">
          <p className="eyebrow text-gold" data-id="element-115" data-mp="mdif1ug4z94g">Tu acceso completo hoy</p>
          <h2 id="offer-heading" className="mt-4 font-display text-[2rem] font-bold leading-[1.1] text-ivory sm:text-4xl" data-id="element-116" data-mp="rdeoi97lrsre">
            Megapack Atletismo 360
          </h2>
          <p className="mt-3 font-sans text-base leading-relaxed text-stone" data-id="element-117" data-mp="2t59i99twlclc">
            Sistema completo: 6 volúmenes + 70 sesiones + 5 bonos.
          </p>
        </div>

        <div className="mt-9 grid gap-6 lg:grid-cols-[1fr_1.1fr] lg:gap-8" data-id="element-118" data-mp="2y4meumakty14">
          <div className="space-y-6" data-id="element-119" data-mp="12oa96x90wbka">
            <div className="rounded-3xl border border-line bg-coal p-6 sm:p-7" data-id="element-120" data-mp="12pcyx1um07ym">
              <p className="eyebrow text-stone" data-id="element-121" data-mp="xvh58bldp799">Valor total de los bonos</p>
              <ul className="mt-5 divide-y divide-line" data-id="element-122" data-mp="syibhu5mn2bl">
                {bonusValueRows.map(row => <li key={row.label} className="flex items-baseline justify-between gap-4 py-2.5 font-sans text-[0.85rem] text-ivory/85" data-id="element-123" data-mp="owwsdr2i1rsy">
                    <span data-id="element-124" data-mp="1lll3s4jpmgte">{row.label}</span>
                    <span className="shrink-0 text-stone" data-id="element-125" data-mp="1gmrt0jvt53wx">{row.value}</span>
                  </li>)}
              </ul>
              <div className="mt-4 flex items-baseline justify-between gap-4 border-t border-gold/30 pt-4" data-id="element-126" data-mp="1ckn0joh3idbv">
                <span className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-gold" data-id="element-127" data-mp="17ltlhrm5ue9l">
                  Valor total de bonos
                </span>
                <span className="font-display text-3xl font-bold leading-none text-gold" data-id="element-128" data-mp="3scawphoac1tm">
                  {bonusValue}
                </span>
              </div>
              <p className="mt-4 font-sans text-[0.82rem] leading-relaxed text-stone" data-id="element-129" data-mp="3trwq0qjm6v34">
                Incluidos hoy sin costo adicional con el sistema completo.
              </p>
            </div>

            <CountdownTimer data-id="element-130" data-mp="3kve07n6ojnar" />
          </div>

          <div className="rounded-3xl border border-gold/40 bg-coal p-6 shadow-lift sm:p-9" data-id="element-131" data-mp="3ou52e8q05v4q">
            <p className="font-sans text-sm text-stone" data-id="element-132" data-mp="3b2zwwpzye8mh">
              Valor normal:{' '}
              <span className="line-through" data-id="element-133" data-mp="3ftyj267mi0xn">{fullPrice}</span>
            </p>
            <p className="mt-2 flex items-start gap-1 font-display font-bold leading-none text-ivory" data-id="element-134" data-mp="3fw1cl07zic74">
              <span className="mt-3 text-2xl text-gold" data-id="element-135" data-mp="364ewapgshmxi">$</span>
              <span className="text-[5rem] leading-none sm:text-[6rem]" data-id="element-136" data-mp="364yi4h9k8vgt">19</span>
            </p>
            <p className="mt-2 font-sans text-xs uppercase tracking-[0.16em] text-stone" data-id="element-137" data-mp="2s55r0ku4gd8b">
              Un solo pago · en tu moneda local
            </p>

            <ul className="mt-7 grid gap-x-6 gap-y-2.5 border-t border-line pt-7 sm:grid-cols-2" data-id="element-138" data-mp="2dhf5xkl89v5y">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 font-sans text-[0.86rem] leading-relaxed text-ivory/85" data-id="element-139" data-mp="28jvuesfwzwhp">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" strokeWidth={2.6} aria-hidden="true" data-id="element-140" data-mp="2mk6hrli0msy4" />
                  {item}
                </li>)}
            </ul>

            <CtaButton size="large" className="mt-8 w-full" data-id="element-141" data-mp="2wfi1ki8a6qcq">
              Acceso completo ahora — {price}
            </CtaButton>

            <p className="mt-4 text-center font-sans text-[11px] text-stone" data-id="element-142" data-mp="2rflxyk3hx0xp">
              Pago seguro · acceso inmediato · garantía de 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}